module.exports = __webpack_public_path__ + "static/img/teto.17b1c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teto.png
// module id = 6dsf
// module chunks = 3